// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__21ovC","footer":"ChangeClinic_footer__H4Nse"};